import React, { Component, PureComponent, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import LoadingSpinner from '../loadingSpinner/';
import Message from '../message/';
import Keyboard from '../keyboard/keyboardInput';

@inject('financeStore', 'dictStore')
@observer
export default class PayoutPage extends Component {

	componentWillMount() {
		this.props.financeStore.init('payout');
	}

	componentWillUnmount() {
    this.props.financeStore.clear('payout');
  }

  handleCloseError = () => {
  	this.props.financeStore.payout.clear();
  }

	render() {

		if (!this.props.financeStore.payout) return false;

		const {isLoading, result} = this.props.financeStore.payout;
		const {getLang} = this.props.dictStore;

		return (
			isLoading ? 
				<div>
					<LoadingSpinner />
				</div> :
					<Fragment>
						<h1>{getLang('PAYOUT')}</h1>
						{result.status ?  <Message text={result.text} type={result.type} onClose={this.handleCloseError}/> : ''}
				    <Payout />
			    </Fragment>
		)
	}
}


@inject('financeStore', 'appStore', 'dictStore')
@observer
class Payout extends Component {

	handleEdit = () => {
		this.props.financeStore.payout.edit();
	}

	handleCancel = () => {
		this.props.financeStore.payout.cancel();
	}

	render() {

		const {data, editStatus, noty} = this.props.financeStore.payout;
		const {name} = this.props.appStore.currency;
		const {getLang} = this.props.dictStore;

		if (noty) {
			return(
				<Noty />
			)
		}

		return(
			<div className="payout">
				{ data  ? 
					<div className="payout-item clearfix">
            <div className="fl_l payout-date">{data.date}</div>
						<div className="fl_r payout-control">
	              <button className="flat_button" onClick={this.handleEdit}>{getLang('EDIT2')}</button>
	              <button  className="flat_button" onClick={this.handleCancel}>{getLang('CANCEL2')}</button>
	          </div>
						<div className="payout-label">
							{ getLang('ACTIVE_PAYMENT') }
							{` ${getLang('FOR_AMOUNT')} ${data.amount} ${name}`}
						</div>
					</div> :
					<div className="payout-no">{getLang('NO_ACTIVE_PAYMENT')}</div> 
				}
				{ !data || editStatus ? <Form /> : '' }
			</div>
		)
	}
}


@inject('financeStore', 'appStore', 'dictStore')
@observer
class Form extends Component {

	handleInput = (e) => {
		this.props.financeStore.payout.inputAmount(e);
	}

	handleOrder = (e) => {
		if (this.props.financeStore.payout.amount <= 0) {
			this.props.financeStore.payout.setResult('AMOUNT_IS_ZERO');
			document.getElementById('payout-amount').focus();
			return false;
		}
		this.props.financeStore.payout.create();
	}

	handleCancel = () => {
		this.props.financeStore.payout.cancel();
	}

	render() {

		const {isLoading, editStatus, amount, wait} = this.props.financeStore.payout;
		const {name} = this.props.appStore.currency;
		const {getLang} = this.props.dictStore;

		return(
			<div className="payout-form">
				<div className="payout-form-input">
					{getLang('AMOUNT')}
					<Keyboard 
						mode="mask"
						mask={[/[1-9]/, /\d||\./, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
						id="payout-amount"
						type="text" 
						maxLength="10"
						ref={el => {this.input = el}}
						onChange={this.handleInput}
						className="form-control" 
						placeholder="1000"
						value={amount}
						positionX="right"
            positionY="bottom"
					/>
					<span>{name}</span>
				</div>
				<div className="payout-form-control">
					{ editStatus ? <button className="flat_button flat_button_inf" onClick={this.handleCancel}>{getLang('CANCEL')}</button> : '' }
					<button className={`flat_button ${wait ? 'wait' : ''}`} disabled={wait} type="submit" onClick={this.handleOrder}>{getLang('ORDER')}</button>
				</div>
			</div>
		)
	}
}

const Noty = () => (
	<div className="payout-note">
   Вы не можете пополнять баланс и заказывать на выплату в данном регионе, т.к. он не является домашним для вашего аккаунта.
   <br />
		Домашним назначается тот регион, в котором было осуществлено первое пополнение баланса.
	<br /> 
		Чтобы отвязать аккаунт от домашнего региона, обратитесь к кассиру или администратору ППС за дальнейшими инструкциями.
	<br /> 
		После снятия привязки домашним будет назначен тот регион, в котором вы осуществите первое пополнение баланса.
   </div>
)



// WEBPACK FOOTER //
// ./src/components/payout/index.js